import { useEffect, useRef, useState } from 'react';
import { Button, cn, Tooltip } from '@sib/ui';
import { Stars } from '@sib/ui/icons';

interface AskAiButtonProps {
  shrink?: boolean;
  buttonLabel?: string;
  handleAskAi?: () => void;
}

export const AskAiButton = ({
  shrink,
  buttonLabel,
  handleAskAi,
}: AskAiButtonProps) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTextTruncated, setIsTextTruncated] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (!element) return;

    setIsTextTruncated(element.scrollWidth > element.clientWidth);
  }, [buttonLabel]);

  return (
    <Tooltip content={isTextTruncated ? buttonLabel : null}>
      <Button
        variant="secondary"
        className={cn('flex max-w-[230px] justify-center px-2')}
        onClick={handleAskAi}
      >
        <span className={cn('flex min-w-0 items-center justify-center gap-0')}>
          <Stars className="h-5 shrink-0" />
          <span
            ref={textRef}
            className={cn(
              'max-w-[200px] truncate pl-2 transition-all duration-300',
              shrink && 'max-w-0 pl-0'
            )}
          >
            {buttonLabel}
          </span>
        </span>
      </Button>
    </Tooltip>
  );
};
